const s = {
  name: "Logs",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,7h11V5H5V7z"/>
		<path class="st0" d="M13,11H5V9h8V11z"/>
		<path class="st0" d="M14,21H5v-2h9V21z"/>
		<path class="st0" d="M5,26h9v-2H5V26z"/>
		<path class="st0" d="M14,31H5v-2h9V31z"/>
		<path class="st0" d="M31,21v4.6l2.7,2.7l-1.4,1.4L29,26.4V21H31z"/>
		<path class="st0" d="M30,36H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h25c1.7,0,3,1.3,3,3v13c5.1,0.5,9,4.8,9,10
			C40,31.5,35.5,36,30,36z M2,3v11h27V3c0-0.5-0.5-1-1-1H3C2.5,2,2,2.5,2,3z M2,16v17c0,0.5,0.5,1,1,1h21c-1.1-0.8-2-1.8-2.7-3H17
			v-2h3.5c-0.3-0.9-0.5-2-0.5-3h-3v-2h3.2c0.2-1.1,0.6-2.1,1.1-3H17v-2h5.9c1.6-1.6,3.7-2.7,6.1-3v0H2z M22,26c0,4.4,3.6,8,8,8
			s8-3.6,8-8s-3.6-8-8-8S22,21.6,22,26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Logs
};
